/**
 * Field definitions index
 *
 * Registers all built-in debug fields with the registry.
 * Import this module to initialize the field registry.
 */

import { DebugFieldRegistry } from '../field-registry';
import { drfFields } from './drf-fields';
import { interestFields } from './interest-fields';
import { metadataFields } from './metadata-fields';
import { principalFields } from './principal-fields';
import { revenueFields } from './revenue-fields';

/**
 * Initialize the field registry with all built-in fields
 */
export function initializeFields(): void {
  const registry = DebugFieldRegistry.getInstance();

  // Skip if already initialized
  if (registry.isInitialized()) {
    return;
  }

  // Register all field categories
  registry.registerMany(revenueFields);
  registry.registerMany(interestFields);
  registry.registerMany(principalFields);
  registry.registerMany(drfFields);
  registry.registerMany(metadataFields);

  // Mark as initialized
  registry.markInitialized();
}

// Re-export field arrays for direct access if needed
export { drfFields } from './drf-fields';
// Re-export formatters
export * from './formatters';
export { interestFields } from './interest-fields';
export { metadataFields } from './metadata-fields';
export { principalFields } from './principal-fields';
export { revenueFields } from './revenue-fields';
